<template>
  <div class="splash">
    <van-swipe class="my-swipe" @change="onChange" :loop="false" :autoplay="3000" indicator-color="white" :style="{ height: fullHeight + 'px' }">
      <van-swipe-item v-for="(image, index) in images" :key="index" @click="goUrl">
        <img v-lazy="image" style="width: 100%; height: 100%;"/>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import { getLocation } from "../../utils/location"
export default {
    'name': 'Splash',
    data() {
        return {
            fullHeight: document.documentElement.clientHeight,
            images: [
                'https://a.chengdai.cn/uploads/images/1080s1882.png'
            ],
            current: 0
        };
    },
    computed: {
      ...mapState({
          cityLocation: state => state.cityLocation
      })
    },
    methods: {
        get_bodyHeight () {//动态获取浏览器高度
            const that = this
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight
                    that.fullHeight = window.fullHeight
                })()
            }
        },
        goUrl() {
            return this.$router.push({path: "/home"});
        },
        onChange(index) {
            this.current = index;
        }
    },
    watch: {
        fullHeight (val) {//监控浏览器高度变化
            if(!this.timer) {
                this.fullHeight = val
                this.timer = true
                let that = this
                setTimeout(function (){
                    that.timer = false
                },400)
            }
        }
    },
    mounted() {
      this.get_bodyHeight();
      getLocation();
      let that = this
      setTimeout(function (){
          that.goUrl();
      },300)
    }
};
</script>

<style scoped>

</style>
